import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const ProcurementSignDocumentTaskDefinition: TaskDefinition<'ProcurementSignDocumentTask'> =
  {
    taskableTypename: 'ProcurementSignDocumentTask',
    getTitle: ({ info }) =>
      i18n.t('tasks.inbox.titles.sign_document_task', {
        taskName: info.purchaseRequest?.description ?? '',
      }),
    getMetadata: () => [],
  }
